import { create } from 'zustand';
import { AddBrandSchemaT } from '../types/schema/brandSchema';

type BrandRequestStore = {
  currentBrand: AddBrandSchemaT | null;
  setCurrentBrand: (brand: AddBrandSchemaT | null) => void;
  clearCurrentBrand: () => void;
};

const useBrandRequestStore = create<BrandRequestStore>(set => ({
  currentBrand: null,
  setCurrentBrand: brand => set({ currentBrand: brand }),
  clearCurrentBrand: () => set({ currentBrand: null }),
}));

export default useBrandRequestStore;
